@if (isHomeRoute()) {
  <a ariaCurrentWhenActive="page" routerLink="/demangler" routerLinkActive="active"
    title="Demangler (C++, D, Rust, MSVC, Itanium)">
    <app-logo-demangler-inline class="apps-box" />
  </a>
  <a ariaCurrentWhenActive="page" routerLink="/formatter" routerLinkActive="active" title="Format C++ code">
    <app-logo-formatter-inline class="apps-box" />
  </a>
  <a ariaCurrentWhenActive="page" routerLink="/naming-style" routerLinkActive="active" title="C++ naming style">
    <app-logo-naming-style-inline class="apps-box" />
  </a>
  <a ariaCurrentWhenActive="page" routerLink="/lighten" routerLinkActive="active" title="Lighten data (JSON / SVG)">
    <app-logo-lighten-inline class="apps-box" />
  </a>
  <a ariaCurrentWhenActive="page" routerLink="/clang-format-config-migrate" routerLinkActive="active"
    title="Migrate version clang-format's config file">
    <app-logo-clang-format-config-migrate-inline class="apps-box" />
  </a>
  <a ariaCurrentWhenActive="page" routerLink="/pdf" routerLinkActive="active" 
    title="Pdf manipulation with ghostscript">
    <app-logo-main-pdf-inline class="apps-box" />
  </a>
}
<router-outlet />

<a href="https://github.com/bansan85/web-demangler">
  <app-github-mark-inline class="github_logo" />
</a>